import { createFileRoute, redirect } from "@tanstack/react-router"
import { can } from "@/utils/can"
import { managementItems } from "@/constants/navigation"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useAuthStore } from "@/stores/useAuthStore"

export const Route = createFileRoute("/beheer/")({
  component: RouteComponent,
  beforeLoad: async () => {
    const roles = useAuthStore.getState().user?.roles

    if (!roles || roles.length === 0) {
      throw redirect({ to: "/geen-rol", replace: true })
    }

    const firstAvailableRoute = managementItems.find((route) =>
      can("read", route.entity),
    )

    if (firstAvailableRoute) {
      throw redirect({ to: firstAvailableRoute.path, replace: true })
    }
  },
})

function RouteComponent() {
  return <ScreenWrapper showManagementMenu />
}
